import { Box, chakra, Flex } from "@chakra-ui/react";

export const CardContainer = chakra(Box, {
  baseStyle: {
    position: "relative",
    bg: "white",
    borderRadius: "12px",
    padding: "8px",
    cursor: "pointer",
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
    transition: "all 0.2s ease-in-out",
    height: "100%",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    _hover: {
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
      transform: "translateY(-2px)",
    },
  },
});

export const IconContainer = chakra(Flex, {
  baseStyle: {
    position: "absolute",
    top: "16px",
    left: "16px",
    color: "purple.500",
    alignItems: "center",
    justifyContent: "center",
    // "& svg": {
    //   width: "20px",
    //   height: "20px",
    // },
  },
});

export const ExpandIcon = chakra(Flex, {
  baseStyle: {
    position: "absolute",
    top: "16px",
    right: "16px",
    color: "purple.500",
    alignItems: "center",
    justifyContent: "center",
    "& svg": {
      width: "18px",
      height: "18px",
    },
  },
});

export const ContentWrapper = chakra(Flex, {
  baseStyle: {
    flex: "1",
    alignItems: "center",
    justifyContent: "flex-start",
    padding: "8px 10px 8px 10px",
  },
});
